// extracted by mini-css-extract-plugin
export var container = "_8d-0";
export var error = "_8d-9";
export var label = "_8d-5";
export var light = "_8d-6";
export var md = "_8d-3";
export var sm = "_8d-2";
export var thin = "_8d-8";
export var thinBold = "_8d-7";
export var vertical = "_8d-4";
export var xs = "_8d-1";